<template>
  <div class="page-module roles-factory">
    <app-header v-bind="headerConfig"></app-header>
    <div class="content" :class="{'scroll-shadow': scrollShadow}" ref="roleContent">
      <div class="inner" ref="roleContentInner">
        <ul class="role-wrapper" ref="roleWrapper">
          <li class="role-list clearfix">
            <div class="role-pic fl">
              <img src="../../static/image/aside.jpg">
            </div>
            <div class="role-detail">
              <ul class="items">
                <li class="row">
                  <span class="hint">系统</span>
                  <div class="name elli">旁白</div>
                </li>
                <li class="row introduce">
                  系统默认的旁白君，会以不同的形式在不同创作 模式中出场。不可修改，不可删除。
                </li>
              </ul>
            </div>
          </li>
          <li v-if="$index > 0" v-for="(role, $index) in storyRoles"
              class="role-list clearfix" @click="openEditMenu(role)">
            <div class="role-pic fl">
              <img :src="commentMethods.getRoleCover(role)">
            </div>
            <div class="role-detail">
              <ul class="items">
                <li class="row">
                  <span class="hint" :class="role.sex" v-text="role.sex ==='man'? '男性': '女性'"></span>
                  <div class="name elli" v-text="commentMethods.roleNameProcess(role.name)"></div>
                </li>
                <li class="row introduce" v-text="role.describe"></li>
              </ul>
            </div>

            <ul class="edit-role-menu" :class="{act: role.editAct}">
              <li class="option del" @click="editRoleList('remove', role.id, 55)">删除角色</li>
              <li class="option edit" @click="editRoleList('change', role.id, 56)">编辑角色</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class="gender man" @click="editRole('man', 57)">
      <i class="gender-bg man-bg"></i>
      <p class="gender-note">新建男性角色</p>
    </div>
    <div class="gender woman" @click="editRole('woman', 58)">
      <i class="gender-bg woman-bg"></i>
      <p class="gender-note">新建女性角色</p>
    </div>

    <div class="start-story" @click="startEditStory">
      开始编剧
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {mapState} from 'vuex';
  import store from '../store/store';
  import AppHeader from '../components/header';
  import {ProjectData} from '../store/ProjectData';
  import {ComponentName, Methods} from '../const/common';

  export default {
    name: 'role_list',
    components: {
      'app-header': AppHeader
    },
    computed: {
      watchRoleWrapperHeight() {
        return this.roleWrapperHeight;
      },
      ...mapState(['moduleState', 'storyRoles', 'createRole'])
    },
    store,
    data() {
      return {
        headerConfig: {
          title: '角色列表',
          isStoryMenu: false,
          backNote: store.state.nextPageHeaderConf.editStoryRole.backNote,
          backPage: store.state.nextPageHeaderConf.editStoryRole.backPage,
          closeModule: ComponentName.EDIT_STORY_ROLE
        },
        commentMethods: Methods,
        contentHeight: 0,
        roleWrapperHeight: 0,
        scrollShadow: false,
        projectData: new ProjectData(this)
      }
    },
    methods: {
      editRole(gender, hash) {
        this.createRole.gender = gender;
        Methods.setHeaderConf('createRole', '作品管理', ComponentName.EDIT_STORY_ROLE);
        Methods.openEditRoleView('init');
        Methods.checkChapterHash(hash);
      },
      editRoleList(type, id, hash) {
        switch (type) {
          case 'change':
            Methods.changRoleInfo(id);
            break;
          case 'remove':
            Methods.removeRole(id);
            break;
        }
        Methods.checkChapterHash(hash);
      },
      openEditMenu(role) {
        this.storyRoles.forEach(function (item) {
          if (role.id !== item.id) {
            Vue.set(item, 'editAct', false);
          }
        });
        Vue.set(role, 'editAct', !role.editAct);
        Methods.checkChapterHash(54);
      },
      startEditStory() {
        Methods.addChapter(false, ComponentName.EDIT_STORY_ROLE);
        Methods.checkChapterHash(59);
      },
    },
    mounted() {
      this.$nextTick(function () {
        var _this = this;

        this.contentHeight = this.$refs.roleContent.clientHeight;
        this.roleWrapperHeight = this.$refs.roleWrapper.clientHeight;
        this.$refs.roleContentInner.onscroll = function () {
          if (_this.contentHeight + _this.$refs.roleContentInner.scrollTop >= _this.roleWrapperHeight) {
            _this.scrollShadow = false;
          } else {
            _this.scrollShadow = true;
          }
        }
      });
      this.projectData.saveStory(function() {}, this);
    },
    watch: {
      watchRoleWrapperHeight() {
        if (this.contentHeight < this.roleWrapperHeight) {
          this.scrollShadow = true;
        }
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/story_role_list.css";
</style>



// WEBPACK FOOTER //
// src/components/edit_story_role.vue